import "../title_pages/title_pages.css"
import { FiCornerDownRight } from "react-icons/fi";

const TitlePages = ({title}) => {
    return (
        <div className="title_pages">
            <div className="row">
                <div className="col-1 icon">
                    <FiCornerDownRight />
                </div>
                <div className="col-11 title">
                    <p>{title}</p>
                </div>
            </div>
        </div>
    )
}

export default TitlePages